export default {
  getEmail: (state) => state.email,
};
